export default __webpack_public_path__ + "static/media/calendar.a36fd0a1.svg";